import React from 'react';
type BadgeVariant = 'healthy' | 'degraded' | 'offline' | 'allowed' | 'denied' | 'warning' | 'neutral';
type BadgeSize = 'sm' | 'md';
interface BadgeProps {
  variant: BadgeVariant;
  size?: BadgeSize;
  children: React.ReactNode;
  dot?: boolean;
}
const variantStyles: Record<BadgeVariant, string> = {
  healthy: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-900/30',
  degraded: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-400 dark:border-amber-900/30',
  offline: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-900/30',
  allowed: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-900/30',
  denied: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-900/30',
  warning: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-400 dark:border-amber-900/30',
  neutral: 'bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700'
};
const dotStyles: Record<BadgeVariant, string> = {
  healthy: 'bg-green-500 dark:bg-green-400',
  degraded: 'bg-amber-500 dark:bg-amber-400',
  offline: 'bg-red-500 dark:bg-red-400',
  allowed: 'bg-green-500 dark:bg-green-400',
  denied: 'bg-red-500 dark:bg-red-400',
  warning: 'bg-amber-500 dark:bg-amber-400',
  neutral: 'bg-slate-500 dark:bg-slate-400'
};
const sizeStyles: Record<BadgeSize, string> = {
  sm: 'px-1.5 py-0.5 text-xs',
  md: 'px-2 py-1 text-xs'
};
export function Badge({
  variant,
  size = 'sm',
  children,
  dot
}: BadgeProps) {
  return <span className={`
        inline-flex items-center gap-1.5 font-medium rounded border
        ${variantStyles[variant]}
        ${sizeStyles[size]}
      `} data-id="element-609">
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${dotStyles[variant]}`} data-id="element-610" />}
      {children}
    </span>;
}